import { environmentRecoil } from '@/recoil/atoms/MobileRecoil/MobileRecoil';
import { SERVICE_APP_NAME } from '@/shared/constants';
import React from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

/**
 * @title 호출할 데이터가 존재하지 않을 때 보여줄 컴포넌트
 *
 * @author 김남규
 * @since 2024-04-28
 */

const NodataBox = styled.div<{ heightPercent?: number }>`
  height: ${(props) => (props.heightPercent ? `${props.heightPercent}%` : '100%')};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3.2rem;
  color: ${(props) => props.theme.colors.disable};
`;

const NoData: React.FC<{ heightPercent?: number; content?: string }> = ({ heightPercent, content }) => {
  const environmentS = useRecoilValue(environmentRecoil);

  const contentsHandler = () => content || (environmentS === 'app' ? SERVICE_APP_NAME : 'No Data');

  const contentText = contentsHandler();

  return (
    <NodataBox heightPercent={heightPercent} className="NodataBox">
      {contentText}
    </NodataBox>
  );
};
export default NoData;
